module.exports = __webpack_public_path__ + "img/barcelona.b29bccc8.png";